import axios from "axios";
import { verifiedBlinkBaseUrl } from "../../constants";

export const blinkActiveBanks = async () => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "GET",
      url: verifiedBlinkBaseUrl,
    })
      .then((res) => {
        if (res.data?.body?.providers) {
          return res.data?.body?.providers;
        } else {
          return [];
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get active banks failed with error: ",
          err?.message
        );
        return [];
      });
  } else {
    return [];
  }
};

export const blinkConnectLink = async (userId, providerId) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedBlinkBaseUrl}/connect-link`,
      data: {
        user_id: userId,
        provider_id: providerId,
      },
    })
      .then((res) => {
        if (res?.data?.body?.data?.authorizationUri) {
          return res?.data?.body?.data?.authorizationUri;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get connect link failed with error: ",
          err?.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const blinkUserAccounts = async (
  userId,
  providerId,
  includeProvider
) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedBlinkBaseUrl}/user-accounts?user_id=${userId}&provider_id=${providerId}`,
    })
      .then((res) => {
        if (res?.data?.body?.accounts) {
          if (includeProvider) {
            return {
              accounts: res?.data?.body?.accounts,
              providerId: res?.data?.body?.providerId,
            };
          } else {
            return res?.data?.body?.accounts;
          }
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get connect link failed with error: ",
          err?.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const blinkCreatePayment = async (
  provider_id,
  payer_id,
  payer_account,
  amount,
  amount_currency_symbol,
  payee_account,
  payee_bank_name,
  payee_bank_country_code
) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedBlinkBaseUrl}/create-payment`,
      data: {
        provider_id,
        payer_id,
        payer_account,
        amount,
        amount_currency_symbol,
        payee_account,
        payee_bank_name,
        payee_bank_country_code,
      },
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error("blink create pament failed with error: ", err?.message);
        return null;
      });
  } else {
    return null;
  }
};

export const blinkPaymentStatus = async (userId, providerId, paymentId) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedBlinkBaseUrl}/payment-status?user_id=${userId}&provider_id=${providerId}&payment_id=${paymentId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get payment status failed with error: ",
          err?.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const blinkCustodyAccounts = async (userId, providerId) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedBlinkBaseUrl}/custody?user_id=${userId}&provider_id=${providerId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get custody accounts failed with error: ",
          err?.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const blinkCustodyOrders = async (userId, providerId) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "GET",
      url: `${verifiedBlinkBaseUrl}/custody-orders?user_id=${userId}&provider_id=${providerId}`,
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error(
          "blink get custody orders failed with error: ",
          err?.message
        );
        return null;
      });
  } else {
    return null;
  }
};

export const blinkCreateOrder = async (userId, providerId, orderBody) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedBlinkBaseUrl}/create-order`,
      data: {
        user_id: userId,
        provider_id: providerId,
        orderBody,
      },
    })
      .then((res) => {
        if (res?.data?.body?.data) {
          return res?.data?.body?.data;
        } else {
          return null;
        }
      })
      .catch(async (err) => {
        console.error("blink create order failed with error: ", err?.message);
        return null;
      });
  } else {
    return null;
  }
};

export const blinkRevokeLastPermission = async (userId, providerId) => {
  if (verifiedBlinkBaseUrl) {
    return await axios({
      method: "POST",
      url: `${verifiedBlinkBaseUrl}/delete-permission`,
      data: {
        user_id: userId,
        provider_id: providerId,
      },
    })
      .then((res) => {
        if (res?.data?.body?.revoked) {
          return true;
        } else {
          return false;
        }
      })
      .catch(async (err) => {
        console.error("blink revove permission faile with error: ", err);
        return false;
      });
  } else {
    return false;
  }
};
